module.exports = __webpack_public_path__ + "static/media/block-balances.e650cc6e.svg";